// For Routes
export const MODULES = {

    // Profile
    personal: 'Personal',
    basicInfo: 'Basic Info',
    familyInfo: 'Family Info',
    contactSocialLinks: 'Contact & Social Links',
    address: 'Address',
    education: 'Education',
    previousEmployer: 'Previous Employer',

    emergencyContact: 'Emergency Contact',

    job: 'Job',
    jobInfo: 'Job Information',
    agreement: 'Agreement',
    compensation: 'Compensation',
    employeeResignation: 'Employee Resignation',
    internshipProbation: 'Internship / Probation',

    myProfileCompletionReport: 'My Profile Completion',

    bankInfo: 'Bank information',

    documents: 'Documents',
    personalDocuments: 'Personal Documents',
    otherDocuments: 'Other Documents',
    personalDocument: 'Personal Document',
    officialDocuments: 'Official Documents',
    signature:'Signature',

    profileUpdateRequest: 'Profile Update Request',
    profileUpdateRequests: 'Profile Update Requests',
	employeeHistory : 'Employment History',

    onboardingTask: 'Onboarding Tasks',

    fullFinalSettlement: 'Full & Final Settlement',
    timelineFeedback: 'Timeline & Feedback',
    healthBenefit: 'Health Benefit',
    covidVaccination: 'Covid-19 Vaccination Status',
    settings: 'Settings',
	payrollSettings: 'Payroll Settings',
	generalSettings: 'General Settings',
	policySettings: 'Policy Settings',
    assets: 'My Assets',
    myFinance: 'My Finance',
    taxRegime: 'Tax Regime',
    salaryTemplate: 'Salary Template',
    salarySlip: 'Salary Slip',

    addPolicy: 'Add Policy',
    editPolicy: 'Edit Policy',

    viewRequest: 'View Request',
    editRequest: 'Edit Request',

    //mail-sent-reports
    mailSentReports: 'Mail Sent Reports',

    // Comp-off
    myCompOff: 'My Comp-Off',
    compOff: 'Comp-Off',
    compOffApproval: 'Comp-Off Approval',
    compOffPolicy: 'Comp-Off Policy',
    addCompOff: 'Add Comp-Off',
    requestCompOff: 'Request Comp-Off',
    compOffRequests: 'Comp-Off Requests',
    compOffRequest: 'Comp-Off Request',

    // Policy Documents
    policyDocuments: 'Policy Documents',
    policyDocument: 'Policy Document',

    // referral policy
    ReferralPolicy: 'Referral Policy',
    Referrals: 'Referral Policy',

    // Timeline and Feedback
    feedbackSettings: 'Feedback Settings',
    praiseSettings: 'Badge',
    coreValue: 'Core Value',
    badge: 'Badge',
    praise: 'Praise',
    feedback: 'Feedback',
    feedbackType: 'Feedback Type',
    feedbackReceived: 'Feedback Received',
    feedbackRequest: 'Feedback Requests',
    surveyRequest: 'Survey Requests',
    internalNote: 'Internal Note',

    // Leave
    leaveRequest: 'Leave Request',
    leaveSettings: 'Leave Settings',

    // Attendance
    attendanceRequest: 'Attendance Request',

    // Overtime
    overtimeRequest: 'Overtime Request',

    // Help Desk
    helpDesk: 'Help Desk',
    categoryList: 'Category List',
    statusList: 'Status List',
    cannedResponses: 'Canned Responses',
    activity: 'Activity List',
    advanceSettings: 'Advance Settings',
    tagList: 'Tag List',

    // Org Structure
    orgStructure: 'Org Structure',
    zone: 'Zone',
    businessUnit: 'Business Unit',

    // trips
    reimbursementRequest: 'Reimbursement Request',
    reimbursement: 'Reimbursement',
    reimbursementModuleType: 'REIMBURSEMENT_TYPE',
    reimbursementType: 'Reimbursement Type',
    approvalChain: 'Approval Chain',
    paymentConfig: 'Payment Configuration',
    employeeExitSetting: 'Employee Resignation Setting',
    employeeRevokeSetting: 'Employee Revoke Setting',

    //Inbox
    signatureRequest: 'Signature Request',
    FFSettlementRequest: 'F&F Request',
    incomeTaxRequest: 'Income Tax Request',

    //productivity
    myRequest: "My Request",
    addRequest: "Add Request",

	/** Settings >> employee Configuration */
    empConfig: 'Employee Configuration',
    empConfigPersonal: 'Personal',
	//Personal >>
	empConfigBasicInfo :"Basic Info",
	empConfigFamilyInfo :"Family Info",
	empConfigContactSocial :"Contact social",
	empConfigBankInfo :"Bank info",
	empConfigAddress:"Address",
	empConfigEducation :"Education",
	empConfigPreviousEmployer :'Previous employer',
	// job
    empConfigJob: 'Job',
	empConfigJobInformation: 'Job info',
	empConfigAgreement: 'Agreement info',
	empConfigCompensation: 'Compensation info',
	empConfigEmployeeResignation: 'Resignation info',
	empConfigInternshipProbation: 'Internship/Probation info',
	empConfigOrgStructure: 'Organization structure',
	// Documents
    empConfigDocuments: 'Documents',
	empConfigDocumentsOther : 'Other Documents',
	//empConfigFamilyInfo >>
	empConfigFamilyDetail :"Family",
	empConfigFamilyNominee :"Nominee",
	empConfigFamilyDependent :"Dependent",
	// contact-social
	empConfigContact: 'Contact information',
	empConfigSocial: 'Social Link',
	// Address
	empConfigCurrentAddress: 'Current Address',
	empConfigPermanentAddress: 'Permanent Address',
	//empConfigPreviousEmployer
	empConfigPreviousEmployerExperience : "Experience",
	empConfigPreviousEmployerFresher : "Fresher"
}


export const ROUTES = {

	myProfile: 'my-profile',
	employeeProfile: 'employees',

	/** EMPLOYEE PROFILE ROUTES : START */
	personal: 'personal',
	basicInfo: 'info',
	familyInfo: 'family-info',
	contactSocial: 'contact',
	bankInfo: 'bank-info', //
	address: 'address',
	education: 'education',
	previousEmployer: 'previous-employer',
	healthBenefit : 'health-benefit',
	vaccinationStatus: 'vaccination-status',
	emergencyContact: 'emergency-contact',
	/** Profile > Job*/
	job: 'job',
	jobInformation: 'info',
	agreement: 'agreement-info',
	compensation: 'compensation',
	employeeResignation: 'resignation',
	internshipProbation: 'probation',
	orgStructure: 'org-structure',
	/** Profile > Documents */
	documents: 'documents',
	personalDocument: 'personal-documents',
	officialDocument: 'official-documents',
	otherDocument: 'other-documents',
	signature: 'signature-documents',
	/** Profile > My Finance*/
	myFinance : 'my-finance',
	taxRegime: 'tax-regime',
	salaryTemplate: 'salary-template',
	salarySlip: 'salary-slip',
	bankInformation: 'bank-info',
	/** Profile > Timeline and feedback*/
	timelineFeedback: 'feedback',
	/** Profile > My assets */
	myAssets : 'assets',
	/** Profile > Profile Update Request */
	profileUpdateRequest: 'profile-update-request',
	/** FNF Settlement */
	fullFinalSettlement: 'settlement',
	/** Profile Completion */
	employeeProfileCompletion: 'my-profile-completion',
	/** Employment History */
	employmentHistory: 'history',
	/** Profile > Settings */
	settings : 'settings',
	payrollSettings: 'payroll',
	generalSettings: 'general',
	policiesSettings: 'policy',
	/** EMPLOYEE PROFILE ROUTES : END */

	// SETTINGS : START
	 /** employee Configuration : start */
    empConfig: 'employee-config',
    empConfigPersonal: 'personal',
	//personal >>
	empConfigBasicInfo :"basic-info",
	empConfigFamilyInfo :"family-info",
	empConfigContactSocial :"contact-social",
	empConfigBankInfo :"bank-info",
	empConfigAddress:"address",
	empConfigEducation :"education",
	empConfigPreviousEmployer :'previous-employer',
	// JOb >>
    empConfigJob: 'job',
	empConfigJobInformation: 'job-info',
	empConfigAgreement: 'agreement-info',
	empConfigCompensation: 'compensation',
	empConfigEmployeeResignation: 'employee-resignation',
	empConfigInternshipProbation: 'internship-probation',
	empConfigOrgStructure: 'org-structure',
	// Documents
    empConfigDocuments: 'documents',
    empConfigDocumentsOther: 'other-documents',
	/** child section routes*/
	//empConfigFamilyInfo >>
	empConfigFamilyDetail :"family-detail",
	empConfigFamilyNominee :"family-nominee",
	empConfigFamilyDependent :"family-dependent",
	/// contact-social
	empConfigContact: 'contact-info',
	empConfigSocial: 'social-info',
	// Address
	empConfigCurrentAddress: 'current-address',
	empConfigPermanentAddress: 'permanent-address',
	//empConfigPreviousEmployer
	empConfigPreviousEmployerExperience : 'experience',
	empConfigPreviousEmployerFresher : 'fresher',
	/** employee Configuration : END */


	// SETTINGS : END
}